var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notfond-wrap"},[_c('div',{staticClass:"number"},[_vm._v("404")]),_c('div',{staticClass:"text"},[_c('span',[_vm._v("没有找到该页面...")]),_c('br'),_vm._v(_vm._s(_vm.timeText)+"秒后自动回到"+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }